import { useState, useEffect } from 'react'
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import { Save, Edit2, Eye, Loader2, FileSignature } from 'lucide-react'
import { getEmailSignature, updateEmailSignature } from '../../services/api'
import toast from 'react-hot-toast'
import '../../styles/email-settings.css'

export default function EmailSignature() {
  const queryClient = useQueryClient()
  const [isEditing, setIsEditing] = useState(false)
  const [signature, setSignature] = useState('')

  // Récupérer la signature
  const { data, isLoading } = useQuery({
    queryKey: ['emailSignature'],
    queryFn: getEmailSignature
  })

  useEffect(() => {
    if (data?.signature !== undefined) {
      setSignature(data.signature)
    }
  }, [data])

  // Mutation pour sauvegarder
  const saveMutation = useMutation({
    mutationFn: () => updateEmailSignature(signature),
    onSuccess: () => {
      queryClient.invalidateQueries(['emailSignature'])
      toast.success('Signature sauvegardée !')
      setIsEditing(false)
    },
    onError: () => {
      toast.error('Erreur lors de la sauvegarde')
    }
  })

  if (isLoading) {
    return (
      <div className="signature-loading">
        <Loader2 size={24} className="spinning" />
        <span>Chargement...</span>
      </div>
    )
  }

  return (
    <div className="email-signature-container">
      <div className="signature-header">
        <div className="signature-title">
          <FileSignature size={20} />
          <h3>Signature Email</h3>
        </div>
        <p className="signature-description">
          Cette signature sera automatiquement ajoutée à la fin de tous vos emails.
        </p>
      </div>

      <div className="signature-content">
        {isEditing ? (
          <>
            <textarea
              value={signature}
              onChange={(e) => setSignature(e.target.value)}
              placeholder="Entrez votre signature email...

Exemple:
--
Jean Dupont
Directeur Commercial
Entreprise SAS
+33 1 23 45 67 89"
              className="signature-textarea"
              rows={10}
            />
            <div className="signature-actions">
              <button
                onClick={() => {
                  setSignature(data?.signature || '')
                  setIsEditing(false)
                }}
                className="signature-btn cancel"
              >
                Annuler
              </button>
              <button
                onClick={() => saveMutation.mutate()}
                disabled={saveMutation.isPending}
                className="signature-btn save"
              >
                {saveMutation.isPending ? (
                  <>
                    <Loader2 size={16} className="spinning" />
                    Sauvegarde...
                  </>
                ) : (
                  <>
                    <Save size={16} />
                    Sauvegarder
                  </>
                )}
              </button>
            </div>
          </>
        ) : (
          <>
            <div className="signature-preview">
              {signature ? (
                <pre className="signature-text">{signature}</pre>
              ) : (
                <p className="signature-empty">
                  Aucune signature définie. Cliquez sur "Modifier" pour en ajouter une.
                </p>
              )}
            </div>
            <div className="signature-actions">
              <button
                onClick={() => setIsEditing(true)}
                className="signature-btn edit"
              >
                <Edit2 size={16} />
                Modifier
              </button>
            </div>
          </>
        )}
      </div>
    </div>
  )
}
